import { Link } from "react-router-dom";
import { Globe, Phone, Mail } from "lucide-react";
import PageMeta from "./PageMeta";

const services = [
  {
    name: "Graham Jasper",
    category: "Rod Builder",
    description: "Builds and repairs fishing rods to a high standard.",
    url: null,
    phone: "07763 461991",
    email: "grahjasper46@gmail.com",
  },
  {
    name: "Dave Dunstan — Premier Baits",
    category: "Bait Supplier",
    description: "High quality bait including lug, black lug, ragworm, sandeel and frozen squid, mackerel, herring etc. Available most days.",
    url: null,
    phone: "07770 688207",
    email: null,
  },
  {
    name: "Camborne Army Surplus",
    category: "Outdoor Clothing & Equipment",
    description: "For all your outdoor equipment, clothing, boots and bags of a professional quality that are built to last.",
    url: "https://www.facebook.com/groups/248171485233761",
    phone: null,
    email: null,
  },
];

const categoryColors = {
  "Rod Builder": "text-cyan-300 border-cyan-300/30 bg-cyan-400/10",
  "Reel Engineer": "text-violet-300 border-violet-300/30 bg-violet-400/10",
  "Bait Supplier": "text-amber-300 border-amber-300/30 bg-amber-400/10",
  "Outdoor Clothing & Equipment": "text-emerald-300 border-emerald-300/30 bg-emerald-400/10",
};

function ServiceCard({ service }) {
  const badgeClass =
    categoryColors[service.category] ||
    "text-slate-300 border-slate-300/30 bg-slate-400/10";

  const inner = (
    <div className="flex flex-col gap-3 rounded-2xl border border-white/10 bg-white/5 p-6 text-left transition hover:border-cyan-300/30 hover:bg-cyan-400/5 h-full panel-lift">
      {/* Category badge */}
      <span
        className={`self-start rounded-full border px-3 py-0.5 text-xs font-semibold ${badgeClass}`}
      >
        {service.category}
      </span>

      {/* Name */}
      <p className="text-base font-bold text-white leading-snug">{service.name}</p>

      {/* Description */}
      {service.description && (
        <p className="text-xs text-slate-400 leading-relaxed">{service.description}</p>
      )}

      {/* Contact info */}
      <div className="mt-auto flex flex-col gap-1.5">
        {service.url && (
          <span className="inline-flex items-center gap-1.5 text-xs text-cyan-300">
            <Globe className="h-3.5 w-3.5 shrink-0" />
            Visit website
          </span>
        )}
        {service.phone && (
          <span className="inline-flex items-center gap-1.5 text-xs text-slate-400">
            <Phone className="h-3.5 w-3.5 shrink-0" />
            {service.phone}
          </span>
        )}
        {service.email && (
          <span className="inline-flex items-center gap-1.5 text-xs text-slate-400">
            <Mail className="h-3.5 w-3.5 shrink-0" />
            {service.email}
          </span>
        )}
      </div>
    </div>
  );

  if (service.url) {
    return (
      <a href={service.url} target="_blank" rel="noopener noreferrer" className="block h-full">
        {inner}
      </a>
    );
  }

  return <div className="h-full">{inner}</div>;
}

export default function ServicesPage() {
  return (
    <div className="page-shell min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 text-white">
      <PageMeta
        title="Local Services | Redruth Sea Angling Association"
        description="Useful local services for Cornwall sea anglers, recommended by Redruth Sea Angling Association."
        keywords="Cornwall angling services, RSAA local services, sea angling club Cornwall"
        url="https://www.redruthseaanglingassociation.co.uk/services"
      />
      <div className="mx-auto max-w-5xl px-6 py-16 sm:px-8 lg:px-12">

        <Link
          to="/"
          className="standalone-only inline-flex items-center gap-2 rounded-lg border border-cyan-300/40 bg-cyan-400/10 px-4 py-2 text-sm text-cyan-200 transition hover:bg-cyan-400/20"
        >
          ← Back
        </Link>

        <div className="mt-8">
          <p className="text-sm font-semibold uppercase tracking-[0.3em] text-cyan-300">Redruth Sea Angling Association</p>
          <h1 className="heading-glow mt-3 text-4xl font-bold tracking-tight text-white sm:text-5xl">Local Services</h1>
          <p className="mt-4 text-base leading-7 text-slate-400">
            A directory of local businesses and services that may be useful to anglers — including rod builders, bait suppliers, and outdoor equipment shops.
          </p>
        </div>

        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((service) => (
            <ServiceCard key={service.name} service={service} />
          ))}
        </div>

        <p className="mt-12 text-center text-xs text-slate-500">
          Know a local service we should list? Get in touch via the{" "}
          <Link to="/" className="text-cyan-400 hover:text-cyan-300 underline">contact section</Link> on our homepage.
        </p>

      </div>
    </div>
  );
}
